import { useEffect, useRef } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Home from './pages/home'
import NotFound from './pages/notfound'
import Header from './components/header'
import Footer from './components/footer'

// Projects
import ProjectsMain from './pages/projects/index'
import MGR from './pages/music_genre_recognition'
import StructuredDataExtraction from './pages/structured-data-extraction'
import AskMeAnything from './pages/ask-me-anything'
import CometHunter from './pages/comet-hunter'
import SixDegreeBacon from './pages/six-degree-bacon'
import HierarchicalMusicGenreClassification from './pages/hierarchical-music-genre-classification'

// Blog Section
import BlogMain from './pages/blog/index'
import Tech from './pages/blog/tech/index'
import Astro from './pages/blog/astro/index'
import TIL from './pages/blog/today-i-learned/index'

// Articles
import QuantizationInLLMs from './pages/blog/tech/quantization-in-llms'
import IndianSoldiersAtThermopylae from './pages/blog/today-i-learned/indian-soldiers-at-thermopylae'

function App() {
  const location = useLocation();
  const firstView = useRef(true);

  // Load GoatCounter (privacy-friendly analytics) once, only if configured.
  // Set REACT_APP_GOATCOUNTER_CODE (e.g. "anandkrishna") in the environment to enable.
  useEffect(() => {
    const code = process.env.REACT_APP_GOATCOUNTER_CODE;
    if (!code || document.querySelector('script[data-goatcounter]')) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = '//gc.zgo.at/count.js';
    s.setAttribute('data-goatcounter', `https://${code}.goatcounter.com/count`);
    document.body.appendChild(s);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Initial pageview is counted by count.js on load; count client-side navigations here.
    if (firstView.current) {
      firstView.current = false;
      return;
    }
    window.goatcounter?.count?.({ path: window.location.pathname + window.location.search });
  }, [location.pathname]);

  return (
    <div className='flex flex-col min-h-screen'>
      <Header />
      <div key={location.pathname} className='flex flex-col flex-grow animate-fadeIn motion-reduce:animate-none'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/projects" element={<ProjectsMain />} />
          <Route path="/projects/comet-hunter" element={<CometHunter />} />
          <Route path="/projects/music-genre-recognition" element={<MGR />} />
          <Route path="/projects/structured-data-extraction" element={<StructuredDataExtraction />} />
          <Route path="/projects/ask-me-anything" element={<AskMeAnything />} />
          <Route path="/projects/six-degree-bacon" element={<SixDegreeBacon />} />
          <Route path="/projects/hierarchical-music-genre-classification" element={<HierarchicalMusicGenreClassification />} />

          {/* blog section */}
          <Route path="/blog" element={<BlogMain />} />
          <Route path="/blog/tech" element={<Tech />} />
          <Route path="/blog/astro" element={<Astro />} />
          <Route path="/blog/today-i-learned" element={<TIL />} />

          {/* articles */}
          <Route path="/blog/tech/quantization-in-llms" element={<QuantizationInLLMs />} />
          <Route path="/blog/today-i-learned/indian-soldiers-at-thermopylae" element={<IndianSoldiersAtThermopylae />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
